module.exports = __webpack_public_path__ + "img/icons8-two-tickets-100.ffef9642.png";